import axios from 'axios'

export default {
  name: 'member-form-contact',

  ui: {
    btSubmit: '[js-submit-button]',
  },

  events: [
    {
      target: 'btSubmit',
      on: 'click',
      handle (e) {
        e.preventDefault()
        this.ui.btSubmit.disabled = true
        axios
          .get(`${this.route}/` /*, {
            id: this.ids,
          } */)
          .then(response => {
            console.log(response.data)
            this.ui.btSubmit.disabled = false
          })
          .catch(function (error) {
            // handle error
            console.log(error)
          })
      },
    },
  ],

  componentDidMount () {
    this.route = this.props && this.props.route ? this.props.route : '/'
  },
}
